import BoxMenu from '@/components/BoxMenu';
import BoxMenuOption from '@/components/BoxMenu/BoxMenuOption';
import colors from '@/design/colors';
import shadows from '@/design/shadows';
import styled from 'styled-components';

export const ConcentracaoBoxMenu = styled(BoxMenu)`
  display: flex;
  width: 135px;
  flex-direction: column;
  align-items: stretch;

  border-radius: 8px;
  border: 1px solid ${colors.purple100};
  background: ${colors.white};

  /* Small Shadow */
  box-shadow: ${shadows.smallShadow};
`;

export const ConcentracaoOption = styled(BoxMenuOption)`
  display: flex;
  align-items: center;
  align-self: stretch;

  :active:not(:disabled),
  :focus:not(:disabled),
  :hover:not(:disabled) {
    background: ${colors.purple50};
  }
`;
